import { Outlet, Link, useLocation } from 'react-router';
import { useState } from 'react';
import {
  LayoutDashboard, Users, Car, Tag, CreditCard, FileText, BookOpen,
  BarChart2, Headphones, Settings, Menu, X, Bell, Search, ChevronDown,
  LogOut, Shield, Package
} from 'lucide-react';
import logo from '../../imports/logo-MORROCARS.png';

const adminNav = [
  { label: 'Dashboard', path: '/admin', icon: <LayoutDashboard className="w-5 h-5" /> },
  { label: 'Users', path: '/admin/users', icon: <Users className="w-5 h-5" /> },
  { label: 'Vehicles', path: '/admin/vehicles', icon: <Car className="w-5 h-5" /> },
  { label: 'Categories', path: '/admin/categories', icon: <Package className="w-5 h-5" /> },
  { label: 'Subscriptions', path: '/admin/subscriptions', icon: <Tag className="w-5 h-5" /> },
  { label: 'Payments', path: '/admin/payments', icon: <CreditCard className="w-5 h-5" /> },
  { label: 'CMS', path: '/admin/cms', icon: <FileText className="w-5 h-5" /> },
  { label: 'Blog', path: '/admin/blog', icon: <BookOpen className="w-5 h-5" /> },
  { label: 'Reports', path: '/admin/reports', icon: <BarChart2 className="w-5 h-5" /> },
  { label: 'Support', path: '/admin/support', icon: <Headphones className="w-5 h-5" /> },
  { label: 'Settings', path: '/admin/settings', icon: <Settings className="w-5 h-5" /> },
];

export function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  return (
    <div className="min-h-screen bg-[#F5F7FA] flex">
      <aside className={`fixed inset-y-0 left-0 z-50 w-64 bg-[#2D323A] transform transition-transform duration-300 lg:translate-x-0 lg:static ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}`}>
        <div className="flex flex-col h-full">
          <div className="flex items-center justify-between p-4 border-b border-white/10">
            <Link to="/">
              <img src={logo} alt="MORROCARS" className="h-9 w-auto brightness-0 invert" />
            </Link>
            <button className="lg:hidden text-white" onClick={() => setSidebarOpen(false)}>
              <X className="w-5 h-5" />
            </button>
          </div>
          <div className="px-3 py-2 border-b border-white/10">
            <div className="flex items-center gap-2 px-3 py-2">
              <Shield className="w-4 h-4 text-[#1E6DFF]" />
              <p className="text-xs text-white/60 uppercase tracking-wider">Admin Panel</p>
            </div>
          </div>
          <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
            {adminNav.map((item) => {
              const isActive = item.path === '/admin'
                ? location.pathname === item.path
                : location.pathname.startsWith(item.path);
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setSidebarOpen(false)}
                  className={`flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all ${
                    isActive
                      ? 'bg-[#1E6DFF] text-white'
                      : 'text-white/70 hover:bg-white/10 hover:text-white'
                  }`}
                >
                  {item.icon}
                  <span>{item.label}</span>
                </Link>
              );
            })}
          </nav>
          <div className="p-4 border-t border-white/10">
            <Link to="/" className="flex items-center gap-3 px-3 py-2.5 rounded-xl text-white/50 hover:bg-white/10 hover:text-white transition-all">
              <LogOut className="w-5 h-5" />
              <span>Sign Out</span>
            </Link>
          </div>
        </div>
      </aside>

      {sidebarOpen && (
        <div className="fixed inset-0 z-40 bg-black/50 lg:hidden" onClick={() => setSidebarOpen(false)} />
      )}

      <div className="flex-1 flex flex-col min-w-0">
        <header className="bg-white border-b border-[#E5E7EB] px-4 lg:px-8 py-4 flex items-center justify-between sticky top-0 z-30">
          <div className="flex items-center gap-4">
            <button className="lg:hidden" onClick={() => setSidebarOpen(true)}>
              <Menu className="w-6 h-6 text-[#2D323A]" />
            </button>
            <div className="relative hidden md:block">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#717182]" />
              <input type="text" placeholder="Search..." className="pl-10 pr-4 py-2 bg-[#F5F7FA] border border-[#E5E7EB] rounded-xl text-sm focus:outline-none focus:border-[#1E6DFF] w-64" />
            </div>
          </div>
          <div className="flex items-center gap-3">
            <button className="relative p-2 text-[#717182] hover:text-[#1E6DFF]">
              <Bell className="w-5 h-5" />
              <span className="absolute top-1 right-1 w-2 h-2 bg-[#EF4444] rounded-full"></span>
            </button>
            <div className="flex items-center gap-2 px-3 py-2 rounded-xl hover:bg-[#F5F7FA] cursor-pointer">
              <div className="w-8 h-8 bg-[#2D323A] rounded-full flex items-center justify-center text-white text-sm">
                <Shield className="w-4 h-4" />
              </div>
              <span className="hidden md:block text-sm text-[#2D323A]">Super Admin</span>
              <ChevronDown className="w-4 h-4 text-[#717182]" />
            </div>
          </div>
        </header>
        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
